import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/main-page/bg-video.mp4'


const _withScopeId = n => (_pushScopeId("data-v-c61059a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video-block__bg" }, null, -1))
const _hoisted_3 = { class: "video-block__text video-block-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "video-block-text__title" }, "Студия дизайна интерьера", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "video-block-text__annotation" }, " Предоставляем полный цикл услуг от проектирования до реализации ремонта жилых и коммерческих помещений ", -1))
const _hoisted_6 = { class: "video-block-text__buttons" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  style: {"display":"flex","object-fit":"cover","background-size":"cover","width":"100%","height":"100vh"},
  preload: "auto",
  loading: "lazy",
  playsinline: "",
  autoplay: "",
  loop: "",
  muted: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AppButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToBlock('request-form')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Рассчитать стоимость проекта")
          ]),
          _: 1
        }),
        _createVNode(_component_AppButton, {
          to: "/projects",
          theme: "white-transparent"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Посмотреть наши работы ")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_7
  ]))
}